import React from 'react';
import TextField from '@mui/material/TextField';
import '../../App.css';
import setSearchCreateDateTillAction from '../../redux/actions/searchReferenceActions/actionSearchCreateDateTill';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });


class SearchCreateDateAndTimeTill extends React.Component {

    constructor(props) {
        super(props);
        this.state = { dateTill: ''};
        this.props.setSearchCreateDateTillFunction(this.state.dateTill);
        this.handleChangeFrom = this.handleChangeFrom.bind(this);

        this.props.setSearchCreateDateTillFunction('');
    }

    handleChangeFrom(event) {
        // console.log(today())

        this.setState({ dateTill: event.target.value }, () => {
           this.props.setSearchCreateDateTillFunction(this.state.dateTill);
        });
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <div className='datePickerCreateTill'>
                    <form className={'datepickerCreateTill'} noValidate onChange={this.handleChangeFrom}>
                        <StyledTextField
                        classes={classes}
                            id="dateCreateTill"
                            style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)', marginBottom: '10px' }}
                            label={t("search_ref.search_date_created_till")}
                            type="date"
                            variant="outlined"
                            defaultValue={''}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
return{
    setSearchCreateDateTillFunction: searchCreateDateTill => {
        dispatch(setSearchCreateDateTillAction(searchCreateDateTill))
    }
}
}
export default connect(null, mapDispatchToProps)(withTranslation()(SearchCreateDateAndTimeTill)); 